import {openTroubleshootingSection} from '../maintenanceTabs/adapter';

/**
 * Canvas Maintenance > Troubleshooting.
 *
 * A destination rather than a record collection: it shows the administrator troubleshooting utilities,
 * and nothing inside it is something the agent acts on yet. So it declares
 * `options` and `view` and no resolver, filter or modal - publishing
 * operations no handler backs is the disagreement the navigation inventory
 * exists to record.
 */
const troubleshootingPlugin = {
	id: 'troubleshooting',
	version: 1,
	commandVersion: 1,
	resource: 'troubleshooting',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.troubleshooting': openTroubleshootingSection,
	},
};

export default troubleshootingPlugin;
